import { useTheme } from '@approvalmax/theme';
import { AmLogo } from '@approvalmax/ui';
import { Flex, Spacing } from '@approvalmax/ui/src/components';
import { browserHelpers } from '@approvalmax/utils';
import { SimplePageLayout } from 'modules/page';
import { FC, memo } from 'react';
import { useSelector } from 'react-redux';
import { useMedia, useMount } from 'react-use';
import { amplitudeService } from 'services/amplitude';

import SignupLoginModule from '../../containers/SignupLoginModule/SignupLoginModule';
import { PageActiveModule } from '../../reducers/page/moduleReducer';
import { getDocumentTitle } from '../../selectors/pageSelectors';
import { StyledContainer } from './SignUpPageContent.styles';

export const SignUpPageContent: FC = memo(() => {
    const documentTitle = useSelector(getDocumentTitle);

    const { theme } = useTheme();
    const isMediumOrBelowScreen = useMedia(`(max-width: ${theme.container.breakpoint.medium})`);

    useMount(() => {
        amplitudeService.sendData('signup: land on register page', {
            signup_version: browserHelpers.isMobile() ? 'mobile' : 'desktop',
        });
    });

    return (
        <SimplePageLayout
            documentTitle={documentTitle}
            showMobileAppButtons
            activeModule={PageActiveModule.SignupModule}
            noContentWrapper
        >
            <Flex direction='column' alignItems='center' spacing='0'>
                <Spacing height={40} />

                <StyledContainer>
                    <Flex
                        size={isMediumOrBelowScreen ? undefined : 14}
                        direction='column'
                        alignItems='center'
                        spacing='0'
                    >
                        <AmLogo width={240} height={47} />

                        <Spacing height={48} />

                        <SignupLoginModule activeModule={PageActiveModule.SignupModule} />
                    </Flex>
                </StyledContainer>

                <Spacing height={40} />
            </Flex>
        </SimplePageLayout>
    );
});

SignUpPageContent.displayName = 'SignUpPageContent';
